<!-- new simple mode for duplicate datasource-->
<ng-container *ngIf="dialogMode === 'simple-warning'; else defaultDialog">
  <nb-card class="simple-card">
    <nb-card-header class="d-flex pb-0 pe-3">
      <morva-icons [icon]="icon"></morva-icons>
      <span class="text me-1">{{ title }}</span>
    </nb-card-header>
    <nb-card-body>
      <div class="content-scrollable" data-testid="content-scrollable">
        <p class="text" [innerHTML]="message | persianNumber"></p>
        <div class="d-flex align-items-center justify-content-center mt-2">
          <button tabindex="-1" (click)="close()">تایید</button>
        </div>
      </div>
    </nb-card-body>
  </nb-card>
</ng-container>

<!-- previous default mode -->
<ng-template #defaultDialog>
  <nb-card>
    <nb-card-header class="d-flex pb-0 pe-3"><morva-icons class="cursor-pointer" [icon]="icon" (click)="close()"></morva-icons><span class="text me-1" [ngClass]="{'message-dialog-title': hideConfirmBtn}">{{title}}</span></nb-card-header>
    <nb-card-body>
      <div class="content-scrollable" data-testid="content-scrollable">
      <p class="text" [innerHTML]="message"></p>
      <p *ngIf="messageDetail" class="text" style="font-size: 12px;">{{messageDetail}}</p>
      <div class="error-container custom-scroll my-2 px-3 py-1" *ngIf="errorMessage">
        <morva-linear-notifiction [message]="errorMessage" messageType="error"></morva-linear-notifiction>
      </div>
      <div *ngIf="errorsList?.length" class="red-box">
        <div class="blue-box-header">
          <div>
            <p class="red-text" data-testid="red-text">
              {{errorsListTitle | persianNumber}}
           </p>
          </div>
           <div class="d-flex justify-content-center align-items-center gap-2">
            <p *ngIf="!isExpanded" class="red-text" data-testid="red-text-more">بیشتر</p>
            <p *ngIf="isExpanded" class="red-text" data-testid="red-text-less">کمتر</p>
              <morva-icons
              (click)="toggleExpand()"
                [icon]="isExpanded ? 'caretUpOutline' : 'caretDownOutline'"
                class="float-end icon-12 cursor-pointer mt-1"
              ></morva-icons>
           </div>
          </div>
          <div *ngIf="isExpanded" class="red-box-body">
            <div class="red-box-inside-body">
              <!-- <div
                *ngIf="errorMessage"
                class="d-flex align-items-center gap-2 mb-2"
              >
                <morva-icons icon="closeCircleRed"></morva-icons>
                <span class="red-text">{{ errorMessage }}</span>
              </div> -->

              <div
                *ngFor="let error of errorsList"
                class="d-flex align-items-center gap-2 mb-1"
              >
                <morva-icons icon="closeCircleRed"></morva-icons>
                <span class="red-text">{{ error }}</span>
              </div>
            </div>
          </div>
        </div>
       <div *ngIf="!hideConfirmBtn" class="d-flex align-items-center justify-content-center mt-2"><button tabindex="-1" (click)="close()">{{btnTitle}}</button></div>
      </div>
    </nb-card-body>
  </nb-card>
</ng-template>
